// @ts-nocheck

import { DefaultPresetsValue } from '../constants/presets';

type Preset = {
  maxOdds: number;
  presets: Array<number>;
};

export const getPresetsFromOdds = (presetsValues: Array<Preset> | null, odds: number) => {
  let tmpPresets = DefaultPresetsValue;

  if (presetsValues) {
    for (let i = 0; i < presetsValues.length; ++i) {
      const current = presetsValues[i];

      if (!current.maxOdds || odds <= current.maxOdds) {
        tmpPresets = current.presets;
        break;
      }
    }
  }
  return tmpPresets;
};

export const getStakeFromPresets = (userPresets: Array<Preset>, odds: number) => {
  if (userPresets) {
    const presets = getPresetsFromOdds(userPresets, odds);
    if (presets && presets[1]) {
      return presets[1] / 100;
    }
  }
  return null;
};
